export default {
  props: ['menuItems'],
  components: {
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    logoUrl() {
      return this.$store.state.settings.logoUrl;
    },
  },
  methods: {
    SetSidebar(status) {
      this.$store.dispatch('app/SetSidebar', status);
    },
  },
};
